import React, { forwardRef } from 'react';
import { FiChevronDown } from 'react-icons/fi';
import { cn } from './cn';

const SIZES = {
  sm: 'h-7 text-caption pl-2 pr-7',
  md: 'h-8 text-body-sm pl-3 pr-8',
  lg: 'h-10 text-body pl-3.5 pr-9',
};

/**
 * Select — styled native select. Keeps native a11y + mobile UX.
 * For a combobox / searchable select, build on top of this in Phase 2.
 */
export const Select = forwardRef(function Select(
  { size = 'md', invalid, className, children, ...rest },
  ref,
) {
  return (
    <div className="relative inline-block w-full">
      <select
        ref={ref}
        className={cn(
          'w-full appearance-none bg-surface text-fg',
          'border rounded-md',
          'transition-[border-color,box-shadow] duration-150 ease-out-soft',
          'focus-visible:outline-none focus-visible:border-brand-500 focus-visible:shadow-focus-ring',
          'disabled:cursor-not-allowed disabled:bg-ink-50 dark:disabled:bg-ink-800 disabled:text-fg-subtle',
          SIZES[size],
          invalid
            ? 'border-danger-500 focus-visible:border-danger-500 focus-visible:shadow-focus-ring-danger'
            : 'border-line',
          className,
        )}
        {...rest}
      >
        {children}
      </select>
      <FiChevronDown
        size={14}
        aria-hidden
        className="pointer-events-none absolute right-2.5 top-1/2 -translate-y-1/2 text-fg-subtle"
      />
    </div>
  );
});

export default Select;
